import { render, staticRenderFns } from "./ReportesCompañia.vue?vue&type=template&id=4ef096a9&"
import script from "./ReportesCompañia.vue?vue&type=script&lang=js&"
export * from "./ReportesCompañia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports